import { ServerIcon } from "@heroicons/react/20/solid";
import ChevronUpDownIcon from "@heroicons/react/24/outline/ChevronUpDownIcon";
import { get } from "lodash-es";
import React, { FC } from "react";

import { ButtonBase, Stack, SvgIcon, Typography } from "@mui/material";
import { common } from "@mui/material/colors";
import { alpha } from "@mui/material/styles";

import { usePopover } from "../../hooks/use-popover";
import { setOrgClusterOpen } from "../../slices/organizations";
import { useDispatch, useSelector } from "../../store";
import { purple } from "../../theme/colors";
import { HostedChip } from "@/components/HostedChip";
import { useIsHostedCluster } from "@/hooks/use-is-hosted-cluster";

export const ClusterPopover: FC = () => {
  const popover = usePopover<HTMLButtonElement>();
  const dispatch = useDispatch();
  const { byId } = useSelector((state) => state.namespaces);
  const { clusterId } = useSelector((state) => state.current);
  const isHostedCluster = useIsHostedCluster();

  function openClusterOrgModal() {
    dispatch(setOrgClusterOpen(true));
  }

  return (
    <ButtonBase
      onClick={openClusterOrgModal}
      ref={popover.anchorRef}
      sx={{
        backgroundColor: alpha(purple.light, 0.45),
        borderColor: purple.dark,
        borderRadius: 1,
        display: "flex",
        px: "12px",
        py: "6px",
        "&:hover": {
          backgroundColor: alpha(common.white, 0.21),
        },
        width: "100%",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <SvgIcon fontSize="small">
          <ServerIcon onClick={openClusterOrgModal} />
        </SvgIcon>
        <Typography
          component="span"
          color="inherit"
          sx={{
            fontSize: 14,
            lineHeight: "24px",
          }}
          className="flex items-center gap-1"
        >
          <span>{`${get(byId, clusterId + ".namespace.name", "")}`}</span>
          {isHostedCluster ? <HostedChip inheritColor /> : null}
        </Typography>
        <SvgIcon color="action" fontSize="small" sx={{ ml: 3 }}>
          <ChevronUpDownIcon />
        </SvgIcon>
      </Stack>
    </ButtonBase>
  );
};
